import Vue from 'vue'
import VueRouter from 'vue-router'

// Routes
import { canNavigate } from '@/libs/acl/routeProtection'
import {checkUser} from '@/auth/utils'

import auth from './routes/auth';
import company from './routes/company';

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: '/',
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  routes: [
    { path: '/', redirect: { name: 'companies' } },
    ...auth,
    ...company,
    {
      path: '/users',
      name: 'users',
      component: () => import('@/views/user/list'),
    },
    {
      path: '/not-authorized',
      name: 'misc-not-authorized',
      component: () => import('@/views/miscellaneous/NotAuthorized.vue'),
      meta: {
        layout: 'full',
      },
    },
    {
      path: '/error-404',
      name: 'error-404',
      component: () => import('@/views/error/Error404.vue'),
      meta: {
        layout: 'full',
      },
    },
    {
      path: '*',
      redirect: 'error-404',
    },
  ],
})

router.beforeEach(async (to, _, next) => {
  const isLoggedIn = await checkUser()
  const isAuthRoute = to.meta.auth
console.log(to)
  if (!isLoggedIn) {
    return isAuthRoute ? next() : next({ name: 'auth-login' })
  }

  if (isAuthRoute) return next('/')

  if (!canNavigate(to)) {
    return next({ name: 'misc-not-authorized' });
  }

  return next();
})

// ? For splash screen
// Remove afterEach hook if you are not using splash screen
router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
    appLoading.style.display = 'none'
  }
})

export default router
